'use client';
import clsx from 'clsx';
import { ArrowDownIcon } from '@/components/icons/svg-icons';
import { styles } from './sidebar-more-item.style'
import { useTranslations } from 'next-intl';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useAnalyseAttribute } from '@/features/next-analyse';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

type SidebarMoreItemProps = {
	isShowMore: boolean;
	setIsShowMore: (isShowMore: boolean) => void;
}

export const SidebarMoreItem = ({ isShowMore, setIsShowMore }: SidebarMoreItemProps) => {
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);
	const analyseAttributeRef = useAnalyseAttribute('toggle-more-menu-button');

	const toggleMoreButton = () => {
		setKafka(isShowMore);
		setIsShowMore(!isShowMore);
	}

	const setKafka = (isShowMore: boolean) => {
		const isMobileMode = window.innerWidth < 750;
		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: 4,
			action: isMobileMode
				? (isShowMore ? 13 : 12) // 13: collapse, 12: expand
				: (isShowMore ? 19 : 18) // 19: collapse, 18: expand
		}
		setKafkaNormal(kafkaData);
	}

	const moreText: string = isShowMore ? 'lbl_Less' : 'lbl_more';

	return (
		<>
			<div
				ref={analyseAttributeRef}
				className={view === ViewEnum.galaxy ? 'side-menu__more' : styles.container}
				data-open={isShowMore}
				onClick={toggleMoreButton}
			>
				<div className={clsx({ [styles.text]: view === ViewEnum.mars })}>{t(moreText)}</div>
				<ArrowDownIcon />
			</div>
		</>
	);
};
